<template>
  <h1>Contato</h1>
  <Link :href="this.route('site.home')" type="button">Inicio</Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link
  }
}
</script>
